import styled from "styled-components";

export const ScheduleFooterStyles = styled.div`
  height: 36px;
  border-top: 1px solid ${({ theme }) => theme.colors.primary[100]};
  display: flex;
  align-items: center;
  padding: 0 18px;
  gap: 18px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.primary[500]};
  background: ${({ theme }) => theme.colors.semantic.container.white};

  .now {
    display: flex;
    align-items: center;
    gap: 6px;

    .bar {
      width: 2px;
      height: 12px;
      background: ${({ theme }) => theme.colors.accent[500]};
    }
  }

  .spacer {
    flex: 1;
  }

  .counts {
    font-variant-numeric: tabular-nums;
  }
`;
